import { Component } from '@angular/core'
import { distinctUntilChanged, shareReplay } from 'rxjs'
import { FlyoutCommunicationService } from 'src/app/libs/fly-out/fly-out-communication.service'

@Component({
  selector: 'flo-fly-out-skeleton',
  templateUrl: './fly-out-skeleton.component.html',
  styleUrls: ['./fly-out-skeleton.component.scss']
})
export class FlyOutSkeletonComponent {
  constructor(private readonly flyoutCommunicationService: FlyoutCommunicationService) {}

  public showFlyout$ = this.flyoutCommunicationService.showFlyout$.pipe(distinctUntilChanged(), shareReplay(1))

  public handleExitClick() {
    this.flyoutCommunicationService.setShowFlyoutValue(false)
  }
}
